import api from "../services/api";

export const getLanguageList = () => api.get("Language");
